export const ENABLE_USER_REGISTER_BY_EMAIL = false;
export const ENABLE_AUTH_BY_EMAIL = true;
export const ENABLE_RESTORE_PASS_BY_EMAIL = false;
